module.exports = __webpack_public_path__ + "static/media/3-focus.f645d068.svg";